import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Navbar } from './components/navbar/navbar';
import { SiteFooter } from './components/site-footer/site-footer';
import { ToastHost } from './components/toast-host/toast-host';
import { ConfirmDialog } from './components/confirm-dialog/confirm-dialog';
import { MemberBanner } from './components/member-banner/member-banner';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Navbar, SiteFooter, ToastHost, ConfirmDialog, MemberBanner],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
